var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-custom-scrollbar", { attrs: { id: "steps-sidebar" } }, [
    _c(
      "div",
      {
        staticClass: "step-container",
        class: {
          "active-step-container": _vm.currentRouteSection === "projects"
        },
        on: {
          click: function($event) {
            return _vm.routeSelector("projects", {})
          }
        }
      },
      [
        _c("SVGStepsFolder"),
        _vm._v(" "),
        _c("div", { staticClass: "step-text" }, [
          _vm._v("\n            Проекты\n        ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "step-container",
        class: { "active-step-container": _vm.currentRouteSection === "photo" },
        on: {
          click: function($event) {
            return _vm.routeSelector("loadPhoto", {
              project: _vm.selectedProject,
              photo: _vm.selectedPhoto
            })
          }
        }
      },
      [
        _c("SVGStepsProjects"),
        _vm._v(" "),
        _c("div", { staticClass: "step-text" }, [
          _vm._v("\n            Фото\n        ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "step-container",
        class: { "active-step-container": _vm.currentRouteSection === "zones" },
        on: {
          click: function($event) {
            return _vm.routeSelector("planeCategories", {
              project: _vm.selectedProject,
              photo: _vm.selectedPhoto
            })
          }
        }
      },
      [
        _c("SVGStepsZones"),
        _vm._v(" "),
        _c("div", { staticClass: "step-text" }, [
          _vm._v("\n            Выделение зон\n        ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "step-container",
        class: {
          "active-step-container": _vm.currentRouteSection === "perspective"
        },
        on: {
          click: function($event) {
            return _vm.routeSelector("SetScale", {
              project: _vm.selectedProject,
              photo: _vm.selectedPhoto
            })
          }
        }
      },
      [
        _c("SVGStepsPerspective"),
        _vm._v(" "),
        _c("div", { staticClass: "step-text" }, [
          _vm._v("\n            Перспектива\n        ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "step-container",
        class: {
          "active-step-container": _vm.currentRouteSection === "grouping"
        },
        on: {
          click: function($event) {
            return _vm.routeSelector("groupingPlanes", {
              project: _vm.selectedProject,
              photo: _vm.selectedPhoto
            })
          }
        }
      },
      [
        _c("SVGGrouping"),
        _vm._v(" "),
        _c("div", { staticClass: "step-text" }, [
          _vm._v("\n            Группировка\n        ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "step-container",
        class: {
          "active-step-container": _vm.currentRouteSection === "design"
        },
        on: {
          click: function($event) {
            return _vm.routeSelector("designList", {
              project: _vm.selectedProject,
              photo: _vm.selectedPhoto
            })
          }
        }
      },
      [
        _c("SVGStepsTextures"),
        _vm._v(" "),
        _c("div", { staticClass: "step-text" }, [
          _vm._v("\n            Дизайн\n        ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "step-container",
        class: {
          "active-step-container": _vm.currentRouteSection === "result"
        },
        on: {
          click: function($event) {
            return _vm.routeSelector("resultSelectDesign", {
              project: _vm.selectedProject,
              design: _vm.selectedDesign
            })
          }
        }
      },
      [
        _c("SVGStepsResult"),
        _vm._v(" "),
        _c("div", { staticClass: "step-text" }, [
          _vm._v("\n            Результат\n        ")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }